const Skeleton = () => {
  return (
    <div className="animate-pulse flex justify-center" data-testid="skeleton">
      <div className="h-14 bg-mid-grey-20 rounded-md w-2/3"></div>
    </div>
  );
};

export default Skeleton;
